module.exports = __webpack_public_path__ + "static/media/tip6.a23156f0.svg";